import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  root: {
    margin: 0,
    // marginLeft: -8,
    borderRadius: 0,
    // marginTop: 50
  },
}));

export default useStyles;